import {
  HTTP_INTERCEPTORS,
  HttpClient,
  HttpClientModule,
} from '@angular/common/http';
import { NgModule } from '@angular/core';
import { GoogleMapsModule } from '@angular/google-maps';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { YouTubePlayerModule } from '@angular/youtube-player';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { OneSignal } from '@ionic-native/onesignal/ngx';
import { ScreenOrientation } from '@ionic-native/screen-orientation/ngx';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { MultiTranslateHttpLoader } from 'ngx-translate-multi-http-loader';
import { environment } from 'src/environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { TabsPageModule } from './pages/tabs/tabs.module';
import { CaptionPipe } from './pipes/caption.pipe';
import { TokenInterceptorService } from './services/token-interceptor.service';
import { registerLocaleData } from '@angular/common';
import localeAr from '@angular/common/locales/ar';
import localeBg from '@angular/common/locales/bg';
import localeCs from '@angular/common/locales/cs';
import localeDe from '@angular/common/locales/de';
import localeEn from '@angular/common/locales/en';
import localeEs from '@angular/common/locales/es';
import localeFa from '@angular/common/locales/fa';
import localeFr from '@angular/common/locales/fr';
import localeHe from '@angular/common/locales/he';
import localeIt from '@angular/common/locales/it';
import localeLt from '@angular/common/locales/lt';
import localeMt from '@angular/common/locales/mt';
import localeNl from '@angular/common/locales/nl';
import localePl from '@angular/common/locales/pl';
import localeRo from '@angular/common/locales/ro';
import localeRu from '@angular/common/locales/ru';
import localeTr from '@angular/common/locales/tr';
import localeUk from '@angular/common/locales/uk';
import { AppVersion } from '@ionic-native/app-version/ngx';
import { SanitizeHtmlPipe } from './pipes/sanitize-html.pipe';

registerLocaleData(localeEn, 'en');
registerLocaleData(localeTr, 'tr');
registerLocaleData(localeDe, 'de');
registerLocaleData(localeIt, 'it');
registerLocaleData(localeCs, 'cs');
registerLocaleData(localeUk, 'uk');
registerLocaleData(localeAr, 'ar');
registerLocaleData(localeBg, 'bg');
registerLocaleData(localeHe, 'he');
registerLocaleData(localeMt, 'mt');
registerLocaleData(localeRu, 'ru');
registerLocaleData(localeFa, 'fa');
registerLocaleData(localeRo, 'ro');
registerLocaleData(localeNl, 'nl');
registerLocaleData(localeFr, 'fr');
registerLocaleData(localeEs, 'es');
registerLocaleData(localePl, 'pl');
registerLocaleData(localeLt, 'lt');

// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
export function createTranslateLoader(http: HttpClient) {
  return new MultiTranslateHttpLoader(http, [
    {
      prefix: './assets/i18n/',
      suffix: '.json',
    },
    ...(environment.hotelId !== 0
      ? [
          {
            prefix: environment.awsURL + environment.hotelId + '/assets/i18/',
            suffix: '.json',
          },
        ]
      : []),
  ]);
}
@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    TabsPageModule,
    IonicModule.forRoot({
      mode: 'ios',
    }),
    AppRoutingModule,
    HttpClientModule,
    TranslateModule.forRoot({
      defaultLanguage: localStorage.getItem('userLang') || 'en',
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
    }),
    FontAwesomeModule,
    GoogleMapsModule,
    YouTubePlayerModule,
  ],
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptorService,
      multi: true,
    },
    AppVersion,
    CaptionPipe,
    SanitizeHtmlPipe,
    OneSignal,
    ScreenOrientation,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
